import React from 'react';

function Payments() {
  return (
    <div
      data-testid="payments"
      className="payments-container vads-u-margin-bottom--4"
    >
      <h3 className="vads-u-margin-top--0 vads-u-margin-bottom--3">Payments</h3>
      <p>
        If you are entitled to back payment (based on an effective date), you
        can expect to receive payment within 1 month of your claim’s decision
        date.
      </p>
    </div>
  );
}

export default Payments;
